<dx-popup
    #accattachmentsPopup
    minWidth="150px"
    minHeight="150px"
    width="45%"
    height="85%"
    title="Documents"
    [showCloseButton]="true"
    [shading]="true"
    [showTitle]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="true"
    [(visible)]="visible"
    (onHidden)="onCloseClick()"
>
    <div *dxTemplate="let data of 'content'">
        <dx-box width="100%" height="100%" direction="col">
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <div class="header-title">
                        <strong>Project</strong>
                    </div>
                    <br />
                    <div
                        class="attachment-button-container"
                        *ngIf="selectedAttachments?.allowAddProjectDocument || isProjectDocs"
                    >
                        <div class="attach-file">
                            <dx-file-uploader
                                #projectFileUploader
                                [accept]="acceptedFileUploadTypes"
                                labelText="Drop file here"
                                uploadMode="useButtons"
                                [multiple]="true"
                                [showFileList]="false"
                                [maxFileSize]="4000000"
                                [visible]="false"
                                (onValueChanged)="onAttachmentsSelect($event, projectDoc)"
                            ></dx-file-uploader>
                        </div>
                        <div *ngIf="!isViewOnly" class="button-content">
                            <dx-button
                                type="default"
                                [text]="attachLocal"
                                [hint]="attachLocal"
                                [icon]="iconAdd"
                                (onClick)="onLocalAttachment(projectDoc)"
                            ></dx-button>
                        </div>
                        <div *ngIf="!!customerId && !isViewOnly" class="button-content">
                            <dx-button
                                type="default"
                                [text]="attachOwner"
                                [hint]="attachOwner"
                                [icon]="iconAdd"
                                (onClick)="onDocumentAttachment(projectDoc)"
                            ></dx-button>
                        </div>
                        <div *ngIf="emailAttachments?.length > 0" class="button-content">
                            <dx-button
                                type="default"
                                [text]="attachEmail"
                                [hint]="attachEmail"
                                [icon]="iconAdd"
                                (onClick)="onEmailDocumentAttachment(projectDoc)"
                                [template]="'buttonTemplate'"
                            >
                                <div *dxTemplate="let buttonData of 'buttonTemplate'">
                                    <div class="button-item-container">
                                        <i [ngClass]="iconAdd"></i>
                                        <div class="button-content">{{ buttonData.text }}</div>
                                        <app-security-info
                                            iconColor="cc-white-icon"
                                            securityIndicator="LOCK"
                                            apiAction="POST"
                                            apiUrl="api/acc"
                                        ></app-security-info>
                                    </div>
                                </div>
                            </dx-button>
                        </div>
                    </div>
                </div>
            </dxi-item>
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <dx-data-grid
                        #attachmentGrid
                        width="100%"
                        height="100%"
                        class="cc-vertical-center-cell-data-grid"
                        [showBorders]="true"
                        [showColumnLines]="true"
                        [showRowLines]="true"
                        [hoverStateEnabled]="true"
                        [dataSource]="selectedProjectAttachments"
                    >
                        <dxi-column caption="File Name" cellTemplate="fileNameTemplate"></dxi-column>

                        <ng-container
                            *ngIf="
                                !isViewOnly &&
                                (selectedAttachments?.allowUnlinkProjectDocument || isProjectDocs || isItemDocs)
                            "
                        >
                            <dxi-column width="100" alignment="center" cellTemplate="unlinkFileTemplate"></dxi-column>
                        </ng-container>

                        <div *dxTemplate="let row of 'fileNameTemplate'">
                            <app-hyperlink-creator
                                cssClass="cc-hyperlink-underline-hover cc-hyperlink-hover"
                                mode="hyperlinkOnly"
                                textLocation="right"
                                [displayText]="row.data.fileName"
                                (onLinkClick)="onDownloadFile(row.data, projectDoc)"
                            >
                                <i class="fa-lg icon-content margin-right-5px" [ngClass]="getFileIcon(row.data)"></i>
                            </app-hyperlink-creator>
                        </div>

                        <div *dxTemplate="let data of 'unlinkFileTemplate'">
                            <dx-button
                                type="default"
                                text="Unlink"
                                [icon]="iconUnlink"
                                (onClick)="onUnlinkDocument(data.data, projectDoc)"
                            ></dx-button>
                        </div>
                    </dx-data-grid>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <hr />
                    <div class="header-title item-header">
                        <strong>Item</strong>
                    </div>

                    <div
                        class="attachment-button-container"
                        *ngIf="selectedAttachments?.allowAddItemDocument || isItemDocs"
                    >
                        <div class="attach-file">
                            <dx-file-uploader
                                #itemfileUploader
                                [accept]="acceptedFileUploadTypes"
                                labelText="Drop file here"
                                uploadMode="useButtons"
                                [multiple]="true"
                                [showFileList]="false"
                                [maxFileSize]="4000000"
                                [visible]="false"
                                (onValueChanged)="onAttachmentsSelect($event, itemDoc)"
                            ></dx-file-uploader>
                        </div>
                        <div *ngIf="!isViewOnly" class="button-content">
                            <dx-button
                                type="default"
                                [hint]="attachLocal"
                                [text]="attachLocal"
                                [icon]="iconAdd"
                                (onClick)="onLocalAttachment(itemDoc)"
                            ></dx-button>
                        </div>
                        <div *ngIf="!!customerId && !isViewOnly" class="button-content">
                            <dx-button
                                type="default"
                                [hint]="attachOwner"
                                [text]="attachOwner"
                                [icon]="iconAdd"
                                (onClick)="onDocumentAttachment(itemDoc)"
                            ></dx-button>
                        </div>
                        <div *ngIf="emailAttachments?.length > 0" class="button-content">
                            <dx-button
                                type="default"
                                [text]="attachEmail"
                                [hint]="attachEmail"
                                [icon]="iconAdd"
                                (onClick)="onEmailDocumentAttachment(itemDoc)"
                            ></dx-button>
                        </div>
                    </div>
                </div>
            </dxi-item>
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <dx-data-grid
                        #attachmentGrid
                        *ngIf="selectedItemAttachments"
                        width="100%"
                        height="100%"
                        class="cc-vertical-center-cell-data-grid"
                        [showBorders]="true"
                        [showColumnLines]="true"
                        [showRowLines]="true"
                        [hoverStateEnabled]="true"
                        [dataSource]="selectedItemAttachments"
                    >
                        <dxi-column caption="File Name" cellTemplate="fileNameTemplate"></dxi-column>

                        <ng-container
                            *ngIf="!isViewOnly && (selectedAttachments?.allowUnlinkItemDocument || isItemDocs)"
                        >
                            <dxi-column
                                width="100"
                                alignment="center"
                                cellTemplate="unlinkItemFileTemplate"
                            ></dxi-column>
                        </ng-container>

                        <div *dxTemplate="let row of 'fileNameTemplate'">
                            <app-hyperlink-creator
                                cssClass="cc-hyperlink-underline-hover cc-hyperlink-hover"
                                mode="hyperlinkOnly"
                                textLocation="right"
                                [displayText]="row.data.fileName"
                                (onLinkClick)="onDownloadFile(row.data, itemDoc)"
                            >
                                <i class="fa-lg icon-content margin-right-5px" [ngClass]="getFileIcon(row.data)"></i>
                            </app-hyperlink-creator>
                        </div>

                        <div *dxTemplate="let data of 'unlinkItemFileTemplate'">
                            <dx-button
                                type="default"
                                text="Unlink"
                                [icon]="iconUnlink"
                                (onClick)="onUnlinkDocument(data.data, itemDoc)"
                            ></dx-button>
                        </div>
                    </dx-data-grid>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <dx-toolbar width="100%">
                        <dxi-item location="before">
                            <div *dxTemplate class="close-button-container">
                                <dx-button
                                    type="default"
                                    text="Close"
                                    [icon]="iconClose"
                                    (onClick)="onCloseClick()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item location="after" [visible]="!docParam">
                            <div *dxTemplate class="close-button-container">
                                <dx-button
                                    type="default"
                                    text="Ok"
                                    [icon]="iconCheck"
                                    (onClick)="onOkClick()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<app-property-community-documents
    #propertyCommunityDocuments
    (onAttach)="onAttachOwnerDocuments($event)"
></app-property-community-documents>

<app-architectural-application-email-attachment-selector
    *ngIf="showEmailAttachmentSelector"
    [attachments]="emailAttachments"
    (onAttachmentSelect)="onAttachEmailAttachments($event)"
    (onClose)="onEmailAttachmentSelectorClose()"
></app-architectural-application-email-attachment-selector>

<cc-message-box #messageBox></cc-message-box>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#accattachmentsPopup' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>
